import React from 'react';
import { useMobxStores } from '@stores/store';
import ImageUnit from '@organisms/media/common/ImageUnit';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
/* 미디어 타입:이미지 */
const MediaSlideData = ({ data }) => {
  const { mediaStore, settingStore } = useMobxStores();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const handleChange = data => {
    mediaStore.setDetailData(data);
    settingStore.setMediaDialogState(true);
    const newUrl = '/' + i18n.language + '/devlog/withBTS?detail=' + data.idx;
    navigate(newUrl);
    // window.history.pushState('', '', newUrl);
  };

  return (
    <>
      <div
        className={'img-hover-zoom w-full cursor-pointer'}
        onClick={() => {
          handleChange(data);
        }}
      >
        <ImageUnit data={data} />
      </div>
    </>
  );
};

export default MediaSlideData;
